<script>
import TextField from "../common/text-field.vue";

export default {
    name: "login-string-field",
    components: {TextField},
    props: {
        property: String,
        label: String,
        placeholder: String,
        autocomplete: String,
        autofocus: Boolean,
        exactLength: Number
    },
    computed: {
        rules() {
            return {
                string: (value) => {
                    if (value) {
                        this.$emit('valid', this.property, true);
                        return true;
                    }

                    this.$emit('valid', this.property, false);
                    return Lang.langGet('You must enter a ') + this.label;
                },
                exactLength: (value) => {
                    if (value && value.length === this.exactLength) {
                        this.$emit('valid', this.property, true);
                        return true;
                    }

                    this.$emit('valid', this.property, false);
                    return Lang.langGet(':name must have exactly :length digits!', {name: this.label, length: this.exactLength});
                }
            }
        },
        computedRules() {
            const rules = [this.rules.string];
            if (this.exactLength) rules.push(this.rules.exactLength);
            return rules;
        }
    }
}
</script>

<template>
    <v-text-field
        validate-on-blur
        aria-label="name" type="text" :name="property"
        :placeholder="placeholder"
        :autofocus="autofocus"
        :rules="computedRules"
        required outlined dense
        :label="label"
        :autocomplete="autocomplete"
    />
</template>
